import React, { useEffect, useState } from "react";
import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import { useFormContext, Controller } from "react-hook-form";
import useUtils from "services/utils/useUtils";

interface IInputProps {
  name: string;
  defaultValue?: number;
  required?: any;
  disabled?: boolean;
  xl?: number;
  md?: number;
  col?: number;
}

const InputCausaDelPago: React.FC<IInputProps> = ({
  name,
  defaultValue,
  required,
  disabled,
  xl = 12,
  md = 12,
  col = 12,
}) => {
  const idCode = name;
  const idDesc = `${name}Descripcion`;

  const { getCausaPago } = useUtils();
  const {
    register,
    control,
    getValues,
    setValue,
    formState: { errors },
    watch,
  } = useFormContext();

  const [data, setData] = useState<Array<{ Codigo: string; Descripcion: string }>>([]);

  useEffect(() => {
    register(idCode);

    getCausaPago().then((res) => {
      setData(res || []);
      console.log(res)
      if (res && res.length > 0) {
        const codeValue = watch(idCode);
        const found = res?.find((c) => parseInt(c.Codigo) === parseInt(codeValue));

        if (found) {
          setValue(idCode, found.Codigo);
          setValue(idDesc, found.Descripcion);
        }
      }
    });
  }, [defaultValue, idCode, idDesc, register, setValue, getValues(idCode)]);

  // Valor que se mostrará si está deshabilitado
  const currentCode = getValues(idCode);
  const currentItem = data.find((d) => d.Codigo === currentCode);
  const disabledDescription = currentItem?.Descripcion || "";

  return (
    <div className={`col-xl-${xl} col-md-${md} col-${col}`}>
      <fieldset className={`input-block input-block--code ${errors?.[idDesc] ? "error" : ""}`}>
        <div className="container-leyend">
          <legend className="input-block--code__legend">Causa del Pago Directo</legend>
        </div>
        <div className="container-inputs-cno-code">
          {/* Código oculto */}
          <input type="hidden" {...register(idCode)} />

          {/* Descripción visible */}
          <div
            className="col-12 auto-complete-component--syncfusion common-form"
            data-input-name={idDesc}
          >
            <Controller
              name={idDesc}
              control={control}
              rules={{ required }}
              render={({ field }) => (
                <AutoCompleteComponent
                  id={idDesc}
                  dataSource={data}
                  fields={{ value: "Descripcion" }}
                  placeholder="Introduzca texto para buscar contingencias"
                  value={disabled ? disabledDescription : field.value || ""}
                  change={(e) => {
                    const selectedDesc = e?.value as string;
                    const item = data.find(d => d.Descripcion === selectedDesc);
                    if (item) {
                      setValue(idCode, item.Codigo);
                      field.onChange(item.Descripcion);
                    }
                  }}
                  onBlur={field.onBlur}
                  enabled={!disabled}
                />
              )}
            />
          </div>
        </div>
        {errors?.[idDesc] && <p className="error m-0">{errors[idDesc]?.message as string}</p>}
      </fieldset>
    </div>
  );
};

export default InputCausaDelPago;
